import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { PageTitleComponent } from '../../../page-title/page-title.component';
import { SelectLoginUserComponent } from '../select-login-user/select-login-user.component';

@Component({
  selector: 'kgr-switch-user',
  templateUrl: './switch-user.component.html',
  styleUrls: ['./switch-user.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PageTitleComponent, SelectLoginUserComponent],
})
export class SwitchUserComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {}

  onLoginResult(success: boolean) {
    this.router.navigate(['/']);
  }
}
